// @ts-nocheck
/* eslint-disable */
import { createPOIListImage } from "~/ui/poilistimage";
import { isFirmFromPoi } from "~/util/review";
import { _ } from "~/i18n";

const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

// TODO: tohle sdili hodne kodu s Search.Visualiser.Item a ten sdileny kod by nemel tedy existovat vice nez jednou
/**
 * @class Jedna polozka vysledku hledani ve sloupci pri tisku
 */
export default class PrintItem {
	constructor(poidata, index) {
		this._dom = {};
		this._data = poidata;
		this._index = index;

		// placena & neplacena firma
		this._paidFirm = isFirmFromPoi(this._data) && this._data.extendedData && this._data.extendedData.paid;
		this._unPaidFirm = isFirmFromPoi(this._data) && this._data.extendedData && !this._data.extendedData.paid;

		this._build();
	}

	getContainer() {
		return this._dom.container;
	}

	_build() {
		this._dom.container = Mapy.Util.node("li");

		var number = Mapy.Util.node("div", { className: "number", innerHTML: this._index + 1 });

		var image = createPOIListImage(this._data, this._paidFirm);
		this._dom.title = Mapy.Util.node("h3");

		// neplacena firma
		if (this._unPaidFirm) {
			this._dom.title.classList.add("no-bold");
		}
		this._dom.box = Mapy.Util.node("div", {className:"content"});
		this._dom.columns = Mapy.Util.node("div");
		this._dom.column1 = Mapy.Util.node("div");
		this._dom.column2 = Mapy.Util.node("div", { className: "col2" });
		this._dom.columns.appendChild(this._dom.column1);
		this._dom.address = Mapy.Util.node("div", {className:"address"});
		this._dom.fuel = Mapy.Util.node("div", {className: "fuel"});

		var liInner = Mapy.Util.node("div", { className: "li-inner" });
		liInner.appendChild(number);
		liInner.appendChild(image);
		liInner.appendChild(this._dom.box);

		this._dom.box.appendChild(this._dom.title);
		this._dom.box.appendChild(this._dom.columns);
		this._dom.container.appendChild(liInner);

		// typ a neni neplacena
		if (this._data.typeName && !this._unPaidFirm) {
			this._dom.columns.before(Mapy.Util.node("p", {className: "type-name", innerHTML: this._data.typeName}));
			this._dom.column1.appendChild(this._dom.address);
		}

		this._setContent();
	}

	_setContent() {
		this._dom.title.innerHTML = this._data.multiTitle && this._data.multiTitle.length > 0 && this._data.multiTitle[0] != "" ? this._data.multiTitle[0] : this._data.title;
		var addr = [].concat(this._data.multiTitle ? this._data.multiTitle.slice(1) : this._data.address);
		if (addr.length) {
			this._dom.address.innerHTML = "<p>" + addr.join("</p><p>") + "</p>";
			this._dom.column1.appendChild(this._dom.address);
		}

		if (this._data.extend && this._data.extend.fuel) {
			this._getFuel(this._data.extend.fuel);
		}

		if (this._paidFirm) {
			this._setPaidFirm();
		}

		// oteviracka
		if (this._data.extend && this._data.extend.opening) {
			var tDate = (new Date(Date.now()));
			var today = (tDate.getMonth() + 1) * 100 + tDate.getDate();
			var opening = this._data.extend.opening;
			if (opening.seasons && opening.seasons.length) {
				for (var i = 0; i < opening.seasons.length; i++) {
					if (
						(
							opening.seasons[i].end > opening.seasons[i].start &&
							(opening.seasons[i].start <= today && opening.seasons[i].end >= today)
						) || (
							opening.seasons[i].end < opening.seasons[i].start && (
								(today >= 101 && today <= opening.seasons[i].end) ||
								(today >= opening.seasons[i].start && today <= 1231)
							)
						)
					) {
						var season = Mapy.Util.node("div");

						if (opening.seasons[i].start != 101 || opening.seasons[i].end != 1231) {
							if (opening.seasons[i].label) {
								season.appendChild(Mapy.Util.node("p", { innerHTML: "<strong>" + opening.seasons[i].label + "</strong>" }));
							} else {
								var startDate = (opening.seasons[i].start % 100) + ". " + _("calendar.months." + MONTHS[(Math.floor(opening.seasons[i].start / 100) - 1)]).toLowerCase();
								var endDate = (opening.seasons[i].end % 100) + ". " + _("calendar.months." + MONTHS[(Math.floor(opening.seasons[i].end / 100) - 1)]).toLowerCase();

								season.appendChild(Mapy.Util.node("p", { innerHTML: "<strong>" + startDate + " &ndash; " + endDate + "</strong>" }));
							}
						}

						this._dom.column2.appendChild(this._buildSeason(opening.seasons[i], tDate.getDay()));
						this._dom.columns.appendChild(this._dom.column2);
					}
				}
			}
		}
	}

	_buildSeason(season, today) {
		// mame aspon jeden den vyplneny
		if (Object.keys(season.days).length) {
			var days = [];
			for (var i = 1; i < 8; i++) {
				var day = season.days[i];
				days.push(_("detail.content.bigDays.nominativ." + (i % 7)) + " " + (day ? this._buildDay(day.interval) : _("detail.content.opening.close")));
			}
			return Mapy.Util.node("p", { innerHTML: days.join("; ") });
			// neni nic, jen mozna poznamka
		} else {
			return Mapy.Util.node("p", { innerHTML: _("detail.content.opening.allWeek") + " " + _("detail.content.opening.close") });
		}
	}

	_buildDay(interval) {
		if (!interval.length) { return _("detail.content.opening.nonstop"); }

		return interval.map(function(inter) {
			return inter.map(function(time) {
				return time.map(function(num, i) {
					return i == 0 ? num : num.toString().padStart(2, "0");
				}).join(":");
			}).join("&ndash;");
		}).join(", ");
	}

	_getFuel(data) {
		// 1 nafta, 2 benzin, 3 lpg, 4 cng
		var data = data.label ? data.value : data;
		for (var i = 0; i < data.length && i < 2; i++) {
			if ([1, 2, 3, 4].indexOf(data[i].id) == -1) { continue; }
			var fuelSpan = Mapy.Util.node("span");
			fuelSpan.setAttribute("itemscope", "itemscope");
			fuelSpan.setAttribute("itemtype", "http://schema.org/Product");

			var priceSpan = Mapy.Util.node("span");
			priceSpan.setAttribute("itemprop", "offers");
			priceSpan.setAttribute("itemscope", "itemscope");
			priceSpan.setAttribute("itemtype", "http://schema.org/Offer");

			var span = Mapy.Util.node("span", {innerHTML: data[i].price, className: "type-" + data[i].id});
			var priceValue = data[i].priceValue || "";
			span.setAttribute("itemprop", "price");
			span.setAttribute("content", priceValue);

			var name = Mapy.Util.node("meta", {"content": data[i].name});
			name.setAttribute("itemprop", "name");

			var currency = Mapy.Util.node("meta", {"content": data[i].currency});
			currency.setAttribute("itemprop", "priceCurrency");


			priceSpan.appendChild(span);
			priceSpan.appendChild(currency);

			fuelSpan.appendChild(name);
			fuelSpan.appendChild(priceSpan);

			this._dom.fuel.appendChild(fuelSpan);
		}

		this._dom.column1.appendChild(this._dom.fuel);
	}

	_setPaidFirm() {
		var paidFirm = Mapy.Util.node("p", { className: "paid-firm" });
		var ext = this._data.extend || {};
		var cont = ext.contact || {};

		// tel
		if (cont.phone && cont.phone.value && cont.phone.value.length) {
			var find = null;

			cont.phone.value.every(function(item) {
				if (item.type == "telefon") {
					find = item;
					return false;
				}
				else return true;
			});

			if (!find) {
				find = cont.phone.value[0];
			}

			var phoneData = "";

			if (find.countrycode != "+420") {
				phoneData = find.countrycode + " ";
			}

			phoneData += find.number.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

			var spanPhone = Mapy.Util.node("span", { innerHTML: phoneData, className: "phone" });
			paidFirm.appendChild(spanPhone);
		}

		// web
		if (cont.url || "www" in cont) {

			if (cont.url) {
				var link = Mapy.Util.node("a", { innerHTML: cont.url.replace(/[#?]utm.+$/, ""), className: "www" });
			} else {
				var link = Mapy.Util.node("a", { innerHTML: cont.www.url.replace(/[#?]utm.+$/, ""), className: "www" });
			}
			paidFirm.appendChild(link);
		}

		this._dom.column1.appendChild(paidFirm);
	}
};
